// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__38cyU","bigColWidth":"Table_bigColWidth__1pKBV","biggerColWidth":"Table_biggerColWidth__1q4F9","row":"Table_row__1L9np","col":"Table_col___gqNc"};